import axios from "axios";
import { EnvironmentConfig } from "@me8eon/config";
import { JwtTokenFn } from "@me8eon/authentication";

export type NexthinkDevice = {
    last_session_event: string;
    "device.collector.uid": string;
    "device.operating_system.name": string;
    "device.name": string;
    "device.hardware.type": string;
    "user.name": string;
}

export type NexthinkDevicesResponse = {
    data: NexthinkDevice[];
}

const API_BASE_URL = `service/nexthink`;

const apiCall = async (
    apiName: string,
    methodType: string,
    payLoad: string | object,
    apiHeaders: Record<string, string> = {}
) => {
    const url = `${EnvironmentConfig.gatewayURL}/${apiName}`;   
    const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    return axios({
        method: methodType,
        url,
        data: typeof payLoad === "object" ? JSON.stringify(payLoad) : "{}",
        headers: { ...headers, ...apiHeaders },
    })
        .then((response) => {
            console.log("success response");
            return response ? response.data : false;
        })
        .catch((error) => {
            console.error("Fetch Error :-S", error);
            return false;
        });
}

export const fetchDeviceDetails = async (
    tokenFn: JwtTokenFn
) => {
    const bearerToken = await tokenFn();
    return apiCall(`${API_BASE_URL}/device-detail`, "POST", {
        queryId: "#last_10_devices_of_user_by_session",
    }, {
        Authorization: `Bearer ${bearerToken}`
    });
};

export const triggerRemoteAction = async (
    remoteActionId: string,
    deviceUid: string,
    tokenFn: JwtTokenFn
) => {
    const triggerInfo: {
        externalSource: string;
        reason: string;
        externalReference: string;
    } = {
        externalSource: "ME@EON Integration",
        reason: "Reason-test",
        externalReference: "me8eon-action",
    };
    const params: {
        ReqFreeSpace?: number;
        TempFilesDays?: number;
    } = {};
    if (remoteActionId.toLowerCase().includes("disk_cleanup")) {
        params.ReqFreeSpace = 1000;
        params.TempFilesDays = 1;
    }
    const bearerToken = await tokenFn();
    return apiCall(`${API_BASE_URL}/trigger-remote-action`, "POST", {
        remoteActionId,
        devices: [deviceUid],
        expiresInMinutes: 60,
        triggerInfo,
        params,
    }, {
        Authorization: `Bearer ${bearerToken}`
    });
};

export const fetchSustainableITInfo = async (
    collectorUid: string,
    tokenFn: JwtTokenFn
) => {
    const bearerToken = await tokenFn();
    return apiCall(`${API_BASE_URL}/sustainable-it`, "POST", {
        queryId: "#sustainable_it",
        parameters: { collector_uid: collectorUid },
    }, {
        Authorization: `Bearer ${bearerToken}`
    });
};

export const fetchHealthCheckInfo = async (collectorUid: string, tokenFn: JwtTokenFn) => {
    try {
        const bearerToken = await tokenFn();
        return apiCall(`${API_BASE_URL}/sustainable-it`, "POST", {
            queryId: "#device_details_api",
            parameters: { collector_uid: collectorUid }
        }, {
            Authorization: `Bearer ${bearerToken}`
        });
    } catch (error) {
        console.error("fetchHealthCheckInfo Error:", error);
        return null;
    }
};

export const fetchTriggerStatus = async (request_id: string, tokenFn: JwtTokenFn) => {
    try {
        const bearerToken = await tokenFn();
        return apiCall(`${API_BASE_URL}/trigger-status`, "POST", {
            queryId: "#get_remote_action_results",
            parameters: { request_id },
        }, {
            Authorization: `Bearer ${bearerToken}`  
        });
    } catch (err) {
        console.error("fetchTriggerStatus---", err);
        return null;
    }
};

export const processRemoteAction = async (
    actionKey: string,
    deviceId: string,
    tokenFn: JwtTokenFn
) => {
    try {
        const triggerResponse = await triggerRemoteAction(
            actionKey,
            deviceId,
            tokenFn
        );
        return triggerResponse;
    } catch (e) {
        console.error("processRemoteAction---", e);
        return null;
    }
};

export const fetchSustainableITReport = async (deviceId: string, tokenFn: JwtTokenFn) => {
    try {
        const result = await fetchSustainableITInfo(deviceId, tokenFn);
        const {
            "Total_energy_consumption.as(format = energy)":
                totalEnergyConsumption,
            "Total_CO2_emissions.as(format = weight)": totalCO2Emitted,
            Days_since_last_full_boot_: daysSinceLastBoot,
            "device.name": deviceName,
            "device.hardware.type": hardwareType,
            "device.boot.days_since_last_full_boot.rating": lastBootRating,
        } = result.data[0];

        return {
            totalCO2Emitted,
            totalEnergyConsumption,
            daysSinceLastBoot,
            deviceName,
            hardwareType,
            lastBootRating,
        };
    } catch (e) {
        console.error("fetchSustainableITReport---", e);
        return null;
    }
};
